import { jsx as d } from "react/jsx-runtime";
import r from "next/image.js";
import s from "../transformImage.js";
const f = r.default || r;
function I({ fill: t, height: i, quality: m, src: e, width: o, ...a }) {
  const n = e.startsWith("https://");
  return /* @__PURE__ */ d(
    f,
    {
      ...a,
      fill: t,
      height: t ? void 0 : i,
      quality: n ? void 0 : m,
      src: n ? s(e, { quality: m, width: o }) : e,
      unoptimized: n,
      width: t ? void 0 : o
    }
  );
}
export {
  I
};
